import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./style.css";
import Swal from "sweetalert2";
import loadConfig from "../../Services/apiService";
import { useDispatch, useSelector } from "react-redux";
import { UpdateAdvertisingPlan } from "../../Redux/Reducers/AdvertisingAndMediaPlanForTheProject";
import UpdatestateApplicationInformationPage from "../../Services/ApplicantInformationPage/UpdateApplicantInformation";
import UpdateSectoreInformationProject from "../../Services/ProjectInformationPage/SectoreInformationProject/UpdateSectoreInformationProject";
import UpdateProjectPlan from "../../Services/ProjectInformationPage/ProjectPlanDetails/UpdateProjectPlan";
import UpdateInformationAboutProject from "../../Services/ProjectInformationPage/ProjectInformation/UpdateInformationAboutProject";
import UpdateGenderMainstreaming from "../../Services/ProjectInformationPage/InformationAboutTheTargetGroup/UpdateGenderMainstreaming";
import UpdateProjectImpact from "../../Services/ProjectInformationPage/ExpectedUnoactProjectTargetGroup/UpdateProjectImpact";
import { useParams } from "react-router-dom";
import { decryptToken } from "../../Services/Account/EncryptionParams";
import { UpdateInformationAboutProjectt } from "../../Redux/Reducers/ProjectInformationPage/ProjectInformation";

function Navbar(props) {
  ///////////////////////////////////////////////////////////////////////////////////////////
  // to read params url
  const location = useLocation();
  // استخراج GUID باستخدام Regular Expression
  const match = window.location.pathname; // قراءة النص بعد أول "/"
  const encryptedToken = match.split("/");
  var guid = encryptedToken[encryptedToken.length - 1];

  ///////////////////////////////////////////////////////////////////////////////////////////

  /////////////////////////////////////////////////////////////////////////////////////////////
  // Definition use state for application url
  const [ApplicationInformation, setApplicationInformation] = useState("");
  const [InformationProject, setInformationProject] = useState("");
  const [InformationProjectSub, setInformationProjectSub] = useState("");
  //معلومات عن الفئة المستهدفة ضمن المشروع
  const [InformationTargetGroupProject, setInformationTargetGroupProject] =
    useState("");
  //تفاصيل خطة عمل المشروع
  const [DetailsProjectWorkPlan, setDetailsProjectWorkPlan] = useState("");
  //الأثر المتوقع للمشروع على الفئة المستهدفة ومعايير الاستدامة
  const [
    ExpectedImpactProjectTargetGroupSustainabilityStandards,
    setExpectedImpactProjectTargetGroupSustainabilityStandards,
  ] = useState("");
  //معلومات عن القطاع وأصالة المشروع
  const [
    InformationSectorOriginalityProject,
    setInformationSectorOriginalityProject,
  ] = useState("");
  //أعضاء فريق العمل - الخبرات السابقة - بناء وحشد الشراكات
  const [TeamMembersPreviousExperience, setTeamMembersPreviousExperience] =
    useState("");
  //الخطة الإعلانية والإعلامية للمشروع
  const [AdvertisingAndMediaPlan, setAdvertisingAndMediaPlan] = useState("");
  //الموازنة والاطار الزمني
  const [BudgetTimeFrame, setBudgetTimeFrame] = useState("");
  // المرفقات والتعهد
  const [AttachmentsAndPledge, setAttachmentsAndPledge] = useState("");
  const [ReportStage, setReportStage] = useState("");
  const [Transfers, setTransfers] = useState("");
  //console.log(encryptedToken,"dfeeefdfsafdsafdsf");

  /////////////////////////////////////////////////////////////////////////////////////////////
  useEffect(() => {
    if (props.location == "manager") {
      setApplicationInformation(`/manager/ApplicationInformation/${guid}`);
      setInformationProjectSub(
        `/manager/InformationProject/InformationProjectSub/${guid}`
      );
      setInformationTargetGroupProject(
        `/manager/InformationProject/InformationTargetGroupProject/${guid}`
      );
      setAdvertisingAndMediaPlan(`/manager/AdvertisingAndMediaPlan/${guid}`);
      setBudgetTimeFrame(`/manager/BudgetTimeFrame/${guid}`);
      setAttachmentsAndPledge(`/manager/AttachmentsAndPledge/${guid}`);
      setReportStage(`/manager/ReportStage/${guid}`);
      setTransfers(`/manager/Transfers/${guid}`);
    } else {
      setApplicationInformation("/ApplicationInformation");
      setInformationProjectSub("/InformationProject/InformationProjectSub");
      setInformationTargetGroupProject(
        `/InformationProject/InformationTargetGroupProject`
      );
      setAdvertisingAndMediaPlan(`/AdvertisingAndMediaPlan`);
      setBudgetTimeFrame(`/BudgetTimeFrame`);
      setAttachmentsAndPledge(`/AttachmentsAndPledge`);
      setReportStage(`/ReportStage`);
      setTransfers(`/Transfers`);
    }
  }, []);

  const [activeLink, setActiveLink] = useState(window.location.pathname);
  const [menuOpen, setMenuOpen] = useState(false);
  const AppGuid = useParams();
  const [jsonData, setJsonData] = useState();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
      ApplicationInformationloding: state.ApplicationInformation,
      BeneficiaryInformation:
        state.BeneficiaryInformation.BeneficiaryInformation,
      GeneralInformation: state.GeneralInformation.GeneralInformation,
      PersonalInformation: state.PersonalInformation.PersonalInformation,
      AdvertisingAndMediaPlanForTheProject:
        state.AdvertisingAndMediaPlanForTheProject
          .AdvertisingAndMediaPlanForTheProject,
      ActiveRound: state.ApplicationInformation.ActiveRound,
      ExpectedProjectImpact: state.ExpectedProjectImpact.ExpectedProjectImpact,
      TargetInfo: state.TargetInfo.TargetInfo,
      ProjectInformation: state.ProjectInformation.ProjectInformation,
      ProjectPlanDetails: state.ProjectPlanDetails.ProjectPlanDetails,
      SectoreInformationProject:
        state.SectoreInformationProject.SectoreInformationProject,
      UpdateInfoAboutProject: state.ProjectInformation.UpdateInfoAboutProject,
      ReportStatusByApplicationGuid:state.TransferItemInformation.ReportStatusByApplicationGuid
    };
  });
  //console.log(AppGuid, "lskdlksdiiiidsd");

  const handleLinkClick = async (path) => {
    //console.log(state.GeneralInformation, "state.ApplicationInformation");
    const shouldDisableFields = !(
      state.ActiveRound == state.ApplicationInformation?.aI_RoundYearId &&
      state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
      window.location.href.includes("manager") == false
    );
    //[,]
    //في حال تم الضغط على اي زر من المنيو يقوم بحفظ المعلومات عند التنقل في حال كانت المعلومات موجوده
    if (!shouldDisableFields) {
      if (
        Object.keys(state.ApplicationInformation).length !== 0 &&
        Object.keys(state.PersonalInformation).length !== 0 &&
        Object.keys(state.BeneficiaryInformation).length !== 0 &&
        Object.keys(state.GeneralInformation).length !== 0
      ) {
        await UpdatestateApplicationInformationPage(
          state.ApplicationInformation,
          state.PersonalInformation,
          state.BeneficiaryInformation,
          state.GeneralInformation
        );
      }
      // if (
      //   Object.keys(state.AdvertisingAndMediaPlanForTheProject).length !== 0
      // ) {
      //   await dispatch(
      //     UpdateAdvertisingPlan({
      //       ...state.AdvertisingAndMediaPlanForTheProject,
      //     })
      //   );
      // }

      //-------------------- project information ------------------------
      if (Object.keys(state.ExpectedProjectImpact).length !== 0) {
        UpdateProjectImpact(
          state.ExpectedProjectImpact.pI_ExpectedProjectImpactOnTargetGroupId,
          state.ExpectedProjectImpact.expectedSocialImpact,
          state.ExpectedProjectImpact.projectImpactOnTargetGroupSkillsAcquired,
          state.ExpectedProjectImpact.projectSustainabilityPlan,
          state.ExpectedProjectImpact.knowledgeTransferPlan,
          state.ExpectedProjectImpact.aI_ApplicationInformationId
        );
      }
      if (Object.keys(state.TargetInfo).length !== 0) {
        UpdateGenderMainstreaming(
          state.TargetInfo.tG_MainTargetedGroupId,
          state.TargetInfo.genderInclusionPlan,
          state.TargetInfo.aI_ApplicationInformationId
        );
      }

      if (Object.keys(state.ProjectInformation).length !== 0) {
        await dispatch(
          UpdateInformationAboutProjectt({
            ...state.ProjectInformation,
          })
        );
      }

      if (Object.keys(state.ProjectPlanDetails).length !== 0) {
        UpdateProjectPlan(
          state.ProjectPlanDetails?.pS_ProjectSummaryId,
          state.ProjectPlanDetails?.mainActivitiesProjectImplementation,
          state.ProjectPlanDetails?.projectPhases,
          state.ProjectPlanDetails?.activitiesInSchools,
          state.ProjectPlanDetails?.educationalContentCreation,
          state.ProjectPlanDetails?.approvalsForSchoolProjects,
          state.ProjectPlanDetails?.plannedElectronicContentInfo,
          state.ProjectPlanDetails?.uniqueProjectValue,
          state.ProjectPlanDetails?.aI_ApplicationInformationId
        );
      }
      if (Object.keys(state.SectoreInformationProject).length !== 0) {
        UpdateSectoreInformationProject(
          state.SectoreInformationProject.sO_sectorAndProjectOriginalityInfoId,
          state.SectoreInformationProject.competitorsIdentification,
          state.SectoreInformationProject.distinguishingFeaturesOfApplicant,
          state.SectoreInformationProject.reasonsSupportingFundingDecision,
          state.SectoreInformationProject.aI_ApplicationInformationId
        );
      }
      Swal.fire({
        position: "center",
        icon: "success",
        title: "تم حفظ المعلومات بنجاح",
        showConfirmButton: false,
        timer: 1000,
        // width: "500px",
      });
    }
    //to move to page that clicked on
    navigate(`/grants${path}`);
    setActiveLink(`/grants${path}`);
    setMenuOpen(false);
  };
  //[,]
  // to change design after clicked on
  const getBackgroundColor = (path) => {
    return activeLink === path || activeLink.includes(path)
      ? "#fff"
      : "#dbdbdbab";
  };
  const getTextColor = (path) => {
    return activeLink === path || activeLink.includes(path)
      ? "#034e84"
      : "#034e84";
  };
  const getboxShadow = (path) => {
    return activeLink === path || activeLink.includes(path)
      ? "1px 1px 1px 1px rgb(9 54 111 / 51%)"
      : "none";
  };
  const gettextDecoration = (path) => {
    return activeLink === path || activeLink.includes(path) ? "none" : "none";
  };
  const getBorderBottom = (path) => {
    return activeLink === path || activeLink.includes(path)
      ? "3.5px solid #18647f"
      : "none";
  };
  // let jsonData = {};
  const dataJson = async () => {
    let jsonData = await loadConfig();

    setJsonData(jsonData);
  };

  useEffect(() => {
    dataJson();
  }, []);

  // console.log(jsonData.ApplicationInfoTip.url,"gg");

  return (
    <>
      {jsonData ? (
        <nav style={{ width: "100%", zIndex: "999" }}>
          <div className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
            &#9776;
          </div>
          <ul className={`navbar nav-links ${menuOpen ? "open" : ""}`}>
            <li
              className="ApplicationInformation "
              onClick={() => handleLinkClick(ApplicationInformation)}
              style={{
                backgroundColor: getBackgroundColor(ApplicationInformation),
                boxShadow: getboxShadow(ApplicationInformation),
                textDecoration: gettextDecoration(ApplicationInformation),
                borderBottom: getBorderBottom(ApplicationInformation),
              }}
              title={jsonData.applicationInformationTap.nameEN}
            >
              <Link
                to={ApplicationInformation}
                style={{ color: getTextColor(ApplicationInformation) }}
              >
                {jsonData.applicationInformationTap.nameAR}
              </Link>
              <a
                className="tipIcon"
                href={jsonData.ApplicationInfoTip.url}
                target="_blank"
                rel="noopener noreferrer"
                title={jsonData.ApplicationInfoTip.PlaceHolder}
              >
                <i id="sds" class={jsonData.ApplicationInfoTip.icon}></i>
              </a>
            </li>
            <li
              className="InformationProject"
              onClick={() => handleLinkClick(InformationProjectSub)}
              style={{
                backgroundColor: getBackgroundColor(InformationProjectSub),
                boxShadow: getboxShadow(InformationProjectSub),
                textDecoration: gettextDecoration(InformationProjectSub),
                borderBottom: getBorderBottom(InformationProjectSub),
              }}
              title={jsonData.projectInformationTap.nameEN}
            >
              <Link
                to={InformationProjectSub}
                style={{ color: getTextColor(InformationProjectSub) }}
              >
                {jsonData.projectInformationTap.nameAR}
              </Link>
              <a
                className="tipIcon"
                href={jsonData.ProjectInfoTip.url}
                target="_blank"
                rel="noopener noreferrer"
                title={jsonData.ProjectInfoTip.PlaceHolder}
              >
                <i id="sds" class={jsonData.ProjectInfoTip.icon}></i>
              </a>
            </li>
            <li
              className="AdvertisingAndMediaPlan"
              onClick={() => handleLinkClick(AdvertisingAndMediaPlan)}
              style={{
                backgroundColor: getBackgroundColor(AdvertisingAndMediaPlan),
                boxShadow: getboxShadow(AdvertisingAndMediaPlan),
                textDecoration: gettextDecoration(AdvertisingAndMediaPlan),
                borderBottom: getBorderBottom(AdvertisingAndMediaPlan),
              }}
              title={jsonData.AdvertisingAndMediaPlanTap.nameEN}
            >
              <Link
                to={AdvertisingAndMediaPlan}
                style={{ color: getTextColor(AdvertisingAndMediaPlan) }}
              >
                {jsonData.AdvertisingAndMediaPlanTap.nameAR}
              </Link>
              <a
                className="tipIcon"
                href={jsonData.AdversTip.url}
                target="_blank"
                rel="noopener noreferrer"
                title={jsonData.AdversTip.PlaceHolder}
              >
                <i id="sds" class={jsonData.AdversTip.icon}></i>
              </a>
            </li>
            <li
              className="BudgetTimeFrame"
              onClick={() => handleLinkClick(BudgetTimeFrame)}
              style={{
                backgroundColor: getBackgroundColor(BudgetTimeFrame),
                boxShadow: getboxShadow(BudgetTimeFrame),
                textDecoration: gettextDecoration(BudgetTimeFrame),
                borderBottom: getBorderBottom(BudgetTimeFrame),
              }}
              title={jsonData.BudgetAndTimeFrameTap.nameEN}
            >
              <Link
                to={BudgetTimeFrame}
                style={{ color: getTextColor(BudgetTimeFrame) }}
              >
                {jsonData.BudgetAndTimeFrameTap.nameAR}
              </Link>
              <a
                className="tipIcon"
                href={jsonData.ApplicationInfoTip.url}
                target="_blank"
                rel="noopener noreferrer"
                title={jsonData.ApplicationInfoTip.PlaceHolder}
              >
                <i id="sds" class={jsonData.ApplicationInfoTip.icon}></i>
              </a>
            </li>
            <li
              className="AttachmentsAndPledge"
              onClick={() => handleLinkClick(AttachmentsAndPledge)}
              style={{
                backgroundColor: getBackgroundColor(AttachmentsAndPledge),
                boxShadow: getboxShadow(AttachmentsAndPledge),
                textDecoration: gettextDecoration(AttachmentsAndPledge),
                borderBottom: getBorderBottom(AttachmentsAndPledge),
              }}
              title={jsonData.applicationInformationTap.nameEN}
            >
              <Link
                to={AttachmentsAndPledge}
                style={{ color: getTextColor(AttachmentsAndPledge) }}
              >
                {jsonData.AttachmentsAndPledge.nameAR}
              </Link>
              <a
                className="tipIcon"
                href={jsonData.AttachmentTip.url}
                target="_blank"
                rel="noopener noreferrer"
                title={jsonData.AttachmentTip.PlaceHolder}
              >
                <i id="sds" class={jsonData.AttachmentTip.icon}></i>
              </a>
            </li>
           { state.ApplicationInformation?.aI_ApplicationStatusId ==
            "561563df-1a04-4d40-8293-3f32c6ae57b5" ?
            <li
              className="ReportStage"
              onClick={() => handleLinkClick(ReportStage)}
              style={{
                backgroundColor: getBackgroundColor(ReportStage),
                boxShadow: getboxShadow(ReportStage),
                textDecoration: gettextDecoration(ReportStage),
                borderBottom: getBorderBottom(ReportStage),
              }}
              title={jsonData.applicationInformationTap.nameEN}
            >
              <Link
                to={ReportStage}
                style={{ color: getTextColor(ReportStage) }}
              >
                {jsonData.RS_ReportStagesNav.nameAR}
              </Link>
              <a
                className="tipIcon"
                href={jsonData.RS_ReportStagesNav.url}
                target="_blank"
                rel="noopener noreferrer"
                title={jsonData.ReportsStageTip.PlaceHolder}
              >
                <i id="sds" class={jsonData.ReportsStageTip.icon}></i>
              </a>
            </li>:""}
            {/* { state.ApplicationInformation?.aI_ApplicationStatusId ==
            "561563df-1a04-4d40-8293-3f32c6ae57b5" ? */}
             { state.ReportStatusByApplicationGuid?.pR_ReportStatusGuid ==
          "80cd0c1e-b4d3-4fbf-acd5-5627c455915b"||state.ReportStatusByApplicationGuid?.pR_ReportStatusGuid=="8dd3e82f-6bc0-43d7-9439-8a63f655a263"
       ?
            <li
              className="Transfers"
              onClick={() => handleLinkClick(Transfers)}
              style={{
                backgroundColor: getBackgroundColor(Transfers),
                boxShadow: getboxShadow(Transfers),
                textDecoration: gettextDecoration(Transfers),
                borderBottom: getBorderBottom(Transfers),
              }}
              title={jsonData.applicationInformationTap.nameEN}
            >
              <Link
                to={Transfers}
                style={{ color: getTextColor(Transfers) }}
              >
                {jsonData.RS_TransfersNav.nameAR}
              </Link>
              <a
                className="tipIcon"
                href={jsonData.RS_TransfersNav.url}
                target="_blank"
                rel="noopener noreferrer"
                title={jsonData.ReportsStageTip.PlaceHolder}
              >
                <i id="sds" class={jsonData.ReportsStageTip.icon}></i>
              </a>
            </li>
            :""} 

            {/* <li
              onClick={() => handleLinkClick("/test")}
              style={{
                backgroundColor: getBackgroundColor("/test"),
                boxShadow: getboxShadow("/test"),
                textDecoration: gettextDecoration("/test"),
                borderBottom: getBorderBottom("/test"),
              }}
            >
              <Link to="/blog" style={{ color: getTextColor("/test") }}>
                test
              </Link>
            </li> */}
          </ul>
          {menuOpen && (
            <div className="overlaynav" onClick={() => setMenuOpen(false)} />
          )}
        </nav>
      ) : (
        ""
      )}
    </>
  );
}

export default Navbar;
